import React, { useEffect, useState } from "react";
import {
    tableEditOrdersApi,
} from "../../redux/apis/table-apis";
import errorToast from "../../components/toast/errorToast";
import successToast from "../../components/toast/successToast";
import { Link } from "react-router-dom";
import { printKOTElectron } from "../../electron-utils/print-helper";

export default function OrderCard({
    order
}) {
    const [parcel, setParcel] = useState(order.parcel);

    useEffect(() => {
        setParcel(order.parcel);
    }, [order]);

    const onParcel = async () => {
        const parcelValue = !parcel;
        setParcel(parcelValue);
        try {
            const products = order.products.map((p) => ({
                ...p,
                parcel: parcelValue,
            }));
            const params = {
                group_id: order.group_id,
                restaurant_table_id: order.restaurant_table_id,
                products,
            };
            const res = await tableEditOrdersApi(params);

            if (res.status === 200) {
                successToast("Order Updated Successfully");
            } else {
                setParcel(!parcelValue);
                errorToast("Order Update Failed. Please retry.");
            }
        } catch (error) {
            console.error(error);
            errorToast("Order Update Failed. Please retry.");
        }
    };

    const printKotFunc = async () => {
        // await printKOT(order.products, order.tableName, parcel);
        printKOTElectron(order.products, order.tableName, parcel);
        //TODO:: KOT PRINT
    };

    return (
        <div className="border border-gray-300 rounded-xl bg-white shadow-sm p-4 space-y-4">
            {order.products.map((item) => (
                <div
                    key={item.id}
                    className="flex items-center border-b border-gray-100 pb-3 last:border-b-0 last:pb-0"
                >
                    {item.photo && (
                        <img
                            src={item.photo}
                            alt={item.name}
                            className="w-14 h-14 rounded-lg object-cover mr-4"
                        />
                    )}

                    <div className="flex-1">
                        <p className="text-gray-900 font-medium text-base truncate">
                            {item.name}
                        </p>
                        <p className="text-gray-600 text-sm">{item.request}</p>
                    </div>
                    <span className="mx-2 text-gray-700">x</span>
                    <div className="w-9 h-9 flex items-center justify-center">
                        <span className="text-lg text-gray-900  font-semibold">
                            {item.qty}
                        </span>
                    </div>
                </div>
            ))}

            <div className="flex items-center justify-between pt-3 border-t border-gray-200">
                <div className="flex items-center space-x-4">
                    <Link
                      to={`/pos/edit-table-products/${order.group_id}`}
                        className="text-sm font-semibold text-gray-800 hover:text-indigo-600"
                    >
                        EDIT
                    </Link>
                    <button
                        onClick={printKotFunc}
                        className="text-sm font-semibold text-gray-800 hover:text-indigo-600"
                    >
                        Print KOT
                    </button>
                    <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                            type="checkbox"
                            checked={parcel}
                            onChange={onParcel}
                            className="form-checkbox text-indigo-600"
                        />
                        <span className="text-sm font-semibold text-gray-800">
                            Parcel
                        </span>
                    </label>
                </div>
                <span className="text-sm font-semibold text-gray-800">
                    at: {order.time}
                </span>
            </div>
        </div>
    );
}
